import { FC } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { LabTestCard } from "./LabTestCard";
import type { DiagnosticUser } from "sdk/diagnosticUser";
import type { LabTest } from "sdk/labTests";

interface Props {
  diagnosticUser: DiagnosticUser;
  labTests: LabTest[];
}

export const LabTestCards: FC<Props> = ({ diagnosticUser, labTests }) => {
  if (!labTests || labTests.length === 0) {
    return (
      <Box p={6} textAlign="center">
        <Text color="fg-main-subtle">No lab tests found.</Text>
      </Box>
    );
  }

  return (
    <Flex direction="column" gap={4} w="full">
      {labTests.map((labTest) => (
        <LabTestCard
          key={labTest.id}
          labTest={labTest}
          userName={`${diagnosticUser.firstName || ""} ${diagnosticUser.lastName || ""}`.trim()}
        />
      ))}
    </Flex>
  );
};
